import { render } from "./BerichtFoerderantragAsideFilters.pug?vue&type=template&id=85533d18&lang=pug"
import script from "./BerichtFoerderantragAsideFilters.js?vue&type=script&lang=js"
export * from "./BerichtFoerderantragAsideFilters.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__